module.exports = __webpack_public_path__ + "static/media/nfc-tag-orange-half.95fd63cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nfc-tag-orange-half.png
// module id = 650
// module chunks = 0